import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getIsNirvanaMode } from "../../ducks/layout/selectors";
import { toggleNirvanaMode as toggleNirvanaModeAction } from "../../ducks/layout/layout";

export const useNirvanaMode = () => {
  const dispatch = useDispatch();
  const isNirvanaMode = useSelector(getIsNirvanaMode);

  const toggleNirvanaMode = useCallback(() => {
    dispatch(toggleNirvanaModeAction());
  }, [dispatch]);

  return {
    isNirvanaMode,
    toggleNirvanaMode,
  };
};
